import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { StudentApi } from '../api/student-api';
import {  BasicUser } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class StudentRepository extends Repository {
  constructor(private studentApi: StudentApi) {
    super();
  }

  getStudentQuery(name: string): Observable<BasicUser[]> {
    return this.studentApi.getStudentQuery(name);
  }
}
